import React from "react";
interface IParentProps {
  bgcolor: string;
  completed: number;
}
type Props = IParentProps;
const ProgressBar: React.FunctionComponent<Props> = (props) => {
  console.log("completed", props.completed)
  const { bgcolor, completed } = props;

  const containerStyles = {
    height: 13,
    width: "100%",
    backgroundColor: "#e0e0de",
    margin: 0,
  };

  // const fillerStyles = {
  //   height: "100%",
  //   width: `${completed}%`,
  //   backgroundColor: bgcolor,
  //   position: `relative`,
  // };


  return (
    <div style={containerStyles}>
      <div style={{
        height: "100%",
        width: `${completed}%`,
        backgroundColor: bgcolor,
        position: `relative`,
      }}>
        <div style={{
          position: `absolute`,
          right: `3px`,
          top: `-1px`,
          color: 'white',
          fontSize: `10px`,
        }}>{completed/20}</div>
      </div>
    </div>
  );
};

export default ProgressBar;
